import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

const ProductMedia = styled.button`
  width: 200px;
  height: 210px;
  position: relative;

  ${props =>
    props.isFallbackImage &&
    css`
      opacity: 0.2;
      max-height: 100%;
      max-width: 100%;
    `}

  ${props =>
    props.more &&
    css`
      cursor: pointer;
    `}

  ${media.smallOnly`
    width: 100px;
    height: 100px;
  `}
`;

const Counters = styled.div`
  padding: 5px 5px;
  position: absolute;
  bottom: 0;
  left: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  transform: translate(-50%, 0);
  color: ${p => p.theme.colors.base500};
  white-space: nowrap; /* Prevent wrapping in mobile mode (kludge) */
`;

export { ProductMedia, Counters };
